// AP-165 · Español — ERP admin.
const es = {
  app_name: "JMS ERP",
  loading: "Cargando…",
  save: "Guardar",
  cancel: "Cancelar",
  edit: "Editar",
  delete: "Eliminar",
  add: "Añadir",
  search: "Buscar",
  actions: "Acciones",
  confirm_delete: "¿Está seguro de que desea eliminar?",
  yes: "Sí",
  no: "No",
  optional: "opcional",
  status: "Estado",
  active: "Activo",
  inactive: "Inactivo",
  filter: "Filtrar",
  clear: "Limpiar",
  all: "Todos",

  login_title: "Accede a tu cuenta",
  login_subtitle: "Gestiona clientes, servicios y pagos con claridad.",
  email: "Correo",
  password: "Contraseña",
  sign_in: "Iniciar sesión",
  signing_in: "Iniciando…",
  invalid_credentials: "Correo o contraseña inválidos",
  logout: "Cerrar sesión",

  nav_dashboard: "Panel",
  nav_customers: "Clientes",
  nav_services: "Servicios",
  nav_payments: "Pagos",
  nav_balance: "Saldo",
  nav_documents: "Documentos",
  nav_appointments: "Citas",
  nav_settings: "Configuración",

  total_customers: "Total Clientes",
  total_services: "Total Servicios",
  total_payments: "Total Pagos",
  outstanding_balance: "Saldo Pendiente",
  recent_payments: "Pagos Recientes",
  no_recent_payments: "Sin pagos recientes.",
  amount: "Monto",
  method: "Método",
  date: "Fecha",

  customers_title: "Clientes",
  customers_subtitle: "Gestiona tus clientes e información de contacto.",
  full_name: "Nombre Completo",
  phone: "Teléfono",
  whatsapp: "WhatsApp",
  address: "Dirección",
  notes: "Notas",
  add_customer: "Nuevo Cliente",
  edit_customer: "Editar Cliente",
  no_customers: "No hay clientes registrados.",

  services_title: "Servicios",
  services_subtitle: "Registra los servicios ofrecidos por tu empresa.",
  service_name: "Nombre del Servicio",
  description: "Descripción",
  price: "Precio",
  add_service: "Nuevo Servicio",
  edit_service: "Editar Servicio",
  no_services: "No hay servicios registrados.",

  payments_title: "Pagos",
  payments_subtitle: "Registra los pagos y sigue el saldo restante.",
  customer: "Cliente",
  service: "Servicio",
  service_price: "Precio del Servicio",
  amount_paid: "Monto Pagado",
  payment_date: "Fecha del Pago",
  payment_method: "Método de Pago",
  remaining_balance: "Saldo Restante",
  add_payment: "Nuevo Pago",
  edit_payment: "Editar Pago",
  no_payments: "No hay pagos registrados.",
  method_cash: "Efectivo",
  method_pix: "PIX",
  method_bank: "Transferencia",
  method_card: "Tarjeta",
  select_customer: "Selecciona un cliente",
  select_service: "Selecciona un servicio",
  select_method: "Selecciona un método",

  balance_title: "Saldo",
  balance_subtitle: "Vista consolidada de pagos y saldos por cliente y servicio.",
  total_price: "Precio Total",
  total_paid: "Total Pagado",
  only_pending: "Solo pendientes",
  no_balance: "Sin saldo para mostrar.",

  settings_title: "Configuración",
  settings_subtitle: "Preferencias de empresa y usuario.",
  company_settings: "Empresa",
  company_name: "Nombre de la Empresa",
  company_logo: "URL del Logotipo",
  currency: "Moneda",
  language: "Idioma",
  user_profile: "Perfil de Usuario",
  name: "Nombre",
  current_password: "Contraseña Actual",
  new_password: "Nueva Contraseña",
  update_profile: "Actualizar Perfil",
  update_company: "Actualizar Empresa",
  saved_successfully: "Guardado con éxito",

  created: "Creado con éxito",
  updated: "Actualizado con éxito",
  deleted: "Eliminado con éxito",
  error_generic: "Ocurrió un error. Inténtalo de nuevo.",

  // AP-165 Fase 2 · Services
  svc_pricing_type: "Tipo de Cobro",
  svc_per_service: "Cobrado por Servicio",
  svc_per_unit: "Cobrado por Unidad",
  svc_per_time: "Cobrado por Tiempo",
  svc_hint_per_unit: "El cliente compra varias unidades (ej.: fotocopia, foto 3x4).",
  svc_hint_per_time: "Cobrado por duración (ej.: consultoría por hora).",
  svc_hint_per_service: "Precio fijo por servicio.",
  svc_unit_label: "Unidad de Medida",
  svc_unit_ph_time: "Hora",
  svc_unit_ph_unit: "Página, Copia, Foto…",
  svc_price_per_unit: "Precio por Unidad",
  svc_price_per_hour: "Precio por Hora",

  // AP-165 Fase 2 · Customers
  cus_view: "Ver:",
  cus_visible: "Visibles",
  cus_hidden: "Ocultos",
  cus_contact: "Contacto",
  cus_hidden_badge: "Cliente oculto",
  cus_open: "Abrir",
  cus_show: "Mostrar cliente",
  cus_hide: "Ocultar cliente",
  cus_delete_title: "Eliminar Cliente",
  cus_delete_desc_1: "El cliente {name} será retirado de la lista principal, pero todos sus datos permanecerán almacenados en el sistema.",
  cus_delete_desc_2: "El Master podrá restaurarlo más tarde desde la Papelera.",
  cus_delete_confirm_q: "¿Desea continuar?",
  cus_attention: "ATENCIÓN",
  cus_show_title: "Mostrar Cliente",
  cus_show_desc: "¿Desea restaurar al cliente {name} a la vista de todos los usuarios autorizados?",
  cus_hide_desc: "¿Desea ocultar al cliente {name}? Todos los datos permanecerán guardados. El cliente simplemente dejará de aparecer para los usuarios comunes.",
  cus_hide_reason_label: "Motivo (opcional)",
  cus_hide_reason_ph: "Ej.: Cliente archivado, revisión interna…",
  cus_btn_show: "Mostrar",
  cus_btn_hide: "Ocultar",

  // AP-165 Fase 2 · Payments
  pay_combobox_placeholder: "Buscar por nombre, CPF, WhatsApp, correo o proceso…",
  pay_combobox_search_ph: "Escriba para buscar…",
  pay_combobox_searching: "Buscando…",
  pay_combobox_empty: "Ningún cliente encontrado.",
  pay_discount_promocao_jms: "Promoción JMS",
  pay_discount_desconto_comercial: "Descuento Comercial",
  pay_discount_cliente_fidelizado: "Cliente Fiel",
  pay_discount_ajuste_preco: "Ajuste de Precio",
  pay_discount_campanha_especial: "Campaña Especial",
  pay_discount_outro: "Otro",
};
export default es;
